<template>
  <div>
    <v-checkbox
      class="mt-5"
      v-model="dark"
      @change="updateDarkMode"
      color="primary"
      on-icon="mdi-moon-waxing-crescent"
      off-icon="mdi-white-balance-sunny"
    ></v-checkbox>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dark: this.$store.state.theme.dark,
    };
  },
  methods: {
    updateDarkMode() {
      this.$store.commit('theme/UPDATE_DARK', this.dark);
      this.$store.commit('style/UPDATE_COLORS', this.dark);
      this.$vuetify.theme.dark = this.dark;
    },
  },
};
</script>
